import PropTypes from "prop-types";
import React from "react";
import getClassNameFactory from "../../../../../utilities/classNames";
import VideoIcon from "@dcl/icons/esm/ui/video";

var VideoCardFooter = function VideoCardFooter(_ref) {
  var runningTime = _ref.runningTime;
  var getClassName = getClassNameFactory(VideoCardFooter.displayName);
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName()
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "icon"
    })
  }, /*#__PURE__*/React.createElement(VideoIcon, null)), runningTime ? /*#__PURE__*/React.createElement("time", null, runningTime) : null);
};

VideoCardFooter.displayName = "VideoCardFooter";
/* eslint-disable max-len */

VideoCardFooter.propTypes = {
  /**
   * Running time for the content, if relevant. Use SI and common non-SI format (English: s = seconds, min = minutes, h = hours, d = days, i.e. "15 min" or "1 h". See https://en.wikipedia.org/wiki/International_System_of_Units#Units_and_prefixes.)
   */
  runningTime: PropTypes.string
};
/* eslint-enable max-len */

VideoCardFooter.defaultProps = {};
export default VideoCardFooter;